<template>
  <div>
    <section class="container page-top hero">
      <span class="pill">{{ page.eyebrow }}</span>
      <h1 class="h-title">{{ page.headline }}</h1>
      <p class="lead">{{ page.body }}</p>
    </section>

    <section v-if="studies.length" class="section container">
      <ul class="grid">
        <li v-for="(study, index) in studies" :key="study.slug" class="card" :style="{ '--tint': tints[index % tints.length] }">
          <span class="industry">{{ study.industry }}</span>
          <h2 class="card-title title">
            <router-link class="stretch" :to="to(`/case-studies/${study.slug}`)">{{ study.title }}</router-link>
          </h2>
          <span class="client">{{ study.clientLabel }}</span>
          <p class="result">{{ study.result }}</p>
          <span class="more" aria-hidden="true">{{ ui('read_case_study') }} {{ arrow }}</span>
        </li>
      </ul>
    </section>

    <CtaBand />
  </div>
</template>

<script setup>
import CtaBand from '../components/CtaBand.vue'
import { useLocale } from '../composables/useLocale'
import { useCaseStudies } from '../composables/useCaseStudies'

const { ui, arrow, to } = useLocale()
const { studies, page } = useCaseStudies()

const tints = ['var(--tint-1)', 'var(--tint-2)', 'var(--tint-3)', 'var(--tint-4)']
</script>

<style scoped>
.hero {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
}

.hero .lead {
  max-width: 56ch;
}

.grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 340px), 1fr));
  gap: 16px;
}

.card {
  position: relative;
  background: var(--tint, var(--surface));
  border-radius: var(--radius-card);
  padding: clamp(24px, 3vw, 36px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  min-height: 300px;
}

.industry {
  font-size: 14px;
  color: var(--tertiary);
}

.title {
  font-size: clamp(24px, 2.4vw, 32px);
  margin: 0;
}

.stretch {
  color: inherit;
  text-decoration: none;
}

.stretch::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: var(--radius-card);
}

.stretch:focus-visible {
  outline: none;
}

.stretch:focus-visible::after {
  outline: 2px solid var(--ink);
  outline-offset: 3px;
}

.client {
  font-size: 15px;
  color: var(--muted);
}

.result {
  font-size: 17px;
  line-height: 1.6;
  color: var(--muted);
  margin: 0;
}

.more {
  margin-top: auto;
  font-weight: 500;
}
</style>
